import React, { PropsWithChildren } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatTab, Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { observer } from 'mobx-react';

type Props = PropsWithChildren<{
    tab: Tabs,
    id?: string,
    header: React.ReactNode,
    disablePadding?: boolean
}>

const Tab: React.FC<Props> = ({
  tab, header, children, disablePadding, id,
}) => {
  const expanded = React.useMemo(() => UiStore.currentTab === formatTab(tab, id), [UiStore.currentTab, tab, id]);

  const handleChange = React.useCallback(() => {
    if (expanded) {
      UiStore.setTab(undefined);
    } else {
      UiStore.setTab(tab, id);
    }
  }, [tab, UiStore.currentTab, expanded]);

  return (
    <Accordion
      elevation={0}
      expanded={expanded}
      disableGutters
      onChange={handleChange}
      sx={{
        borderRadius: '10px !important',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="large" />} sx={{ px: 1.5 }}>
        {header}
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, ...(disablePadding && { px: 0 }) }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default observer(Tab);
